export default function WhyChooseHsm() {
    return (
        <>
            <section id="why-choose-hsm-offline-section">
                <div className="why-choose-hsm-offline-container">
                    <div className="why-choose-hsm-offline-header">
                        <h2 className="section-title">Why Choose HSM Offline</h2>
                        <p className="section-subtitle">Experience the difference of in-person music education</p>
                    </div>

                    <div className="why-choose-hsm-offline-content">
                        <div className="why-choose-hsm-offline-grid">
                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                        <circle cx="12" cy="7" r="4" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Expert Faculty</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                        <polyline points="14,2 14,8 20,8" />
                                        <line x1="16" y1="13" x2="8" y2="13" />
                                        <line x1="16" y1="17" x2="8" y2="17" />
                                        <polyline points="10,9 9,9 8,9" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Structured Curriculum</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 12l2 2 4-4" />
                                        <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
                                        <path d="M12 2v4" />
                                        <path d="M12 18v4" />
                                        <path d="M4.93 4.93l2.83 2.83" />
                                        <path d="M16.24 16.24l2.83 2.83" />
                                        <path d="M2 12h4" />
                                        <path d="M18 12h4" />
                                        <path d="M4.93 19.07l2.83-2.83" />
                                        <path d="M16.24 7.76l2.83-2.83" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Hands-On Learning</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                        <circle cx="8.5" cy="8.5" r="1.5" />
                                        <polyline points="21,15 16,10 5,21" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Practice Facilities</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                        <path d="M8 9h8" />
                                        <path d="M8 13h6" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Counseling and Mentorship</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 18V5l12-2v13" />
                                        <circle cx="6" cy="18" r="3" />
                                        <circle cx="18" cy="16" r="3" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Performance Coaching</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Performance Opportunities</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                        <circle cx="12" cy="7" r="4" />
                                        <path d="M12 11v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Personalized Attention</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Collaborative Learning</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Track Your Progress</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                        <polyline points="9,22 9,12 15,12 15,22" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Inspiring Campus Culture</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                        <path d="M8 9h8" />
                                        <path d="M8 13h6" />
                                        <path d="M8 17h4" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Individualized Feedback</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                        <polyline points="7.5,4.21 12,6.81 16.5,4.21" />
                                        <polyline points="7.5,19.79 7.5,14.6 3,12" />
                                        <polyline points="21,12 16.5,14.6 16.5,19.79" />
                                        <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
                                        <line x1="12" y1="22.08" x2="12" y2="12" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Career Guidance</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        <path d="M12 11v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Community Engagement</h3>
                                </div>
                            </div>

                            <div className="why-choose-hsm-offline-item">
                                <div className="item-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        <path d="M12 11v4" />
                                        <path d="M12 17h.01" />
                                    </svg>
                                </div>
                                <div className="item-content">
                                    <h3 className="item-title">Examination Preparation</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 